import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Heading, Spacer } from '@zillow/constellation';

import { PHONE_VERIFICATION_STEPS } from 'app/shared/constants/WizardStepsConstants';
import AddPhoneNumber from './components/AddPhoneNumber';
import Finished from './components/Finished';
import GetVerificationCode from './components/GetVerificationCode';
import VerificationCodeSent from './components/VerificationCodeSent';

import { StyledWrapper, StyledModalDialog } from './StyledComponents';

const propTypes = {
    headerText: PropTypes.string.isRequired,
    initialStep: PropTypes.number,
    isNumberEditable: PropTypes.bool,
    numberToVerify: PropTypes.string,
    onPhoneNumberAdded: PropTypes.func, // eslint-disable-line react/require-default-props
    onRequestVerificationCode: PropTypes.func, // eslint-disable-line react/require-default-props
    onVerificationConfirmation: PropTypes.func, // eslint-disable-line react/require-default-props
    showVerificationModal: PropTypes.func.isRequired,
    stepsConfig: PropTypes.array.isRequired,
    verificationSuccessfulCTAText: PropTypes.string,
};

const defaultProps = {
    initialStep: 0,
    isNumberEditable: true,
    numberToVerify: '',
    verificationSuccessfulCTAText: 'Return to listing',
};

const PhoneVerificationWizard = ({
    headerText,
    initialStep,
    isNumberEditable,
    numberToVerify,
    onPhoneNumberAdded,
    onRequestVerificationCode,
    onVerificationConfirmation,
    showVerificationModal,
    stepsConfig,
    verificationSuccessfulCTAText,
}) => {
    const [currentStepIndex, setCurrentStepIndex] = useState(initialStep);
    const [phoneNumberToVerify, setPhoneNumberToVerify] = useState(numberToVerify);
    const [verificationType, setVerificationType] = useState('');

    const incrementStep = (stepToJumpTo) => {
        if (stepToJumpTo) {
            const stepToJumpToIndex = stepsConfig.findIndex(element => element === stepToJumpTo);
            setCurrentStepIndex(stepToJumpToIndex);
        } else {
            setCurrentStepIndex(currentStepIndex + 1);
        }
    };

    return (
        <StyledModalDialog
            header={<Heading level={6}>{headerText}</Heading>}
            isOpen={true}
            onClose={() => showVerificationModal(false)}
            shouldCloseOnOutsideClick={false}
            wide={true}
            body={(
                <div className="PhoneVerificationWizard">
                    <Spacer marginTop="xs" />
                    <StyledWrapper>
                        {stepsConfig[currentStepIndex] === PHONE_VERIFICATION_STEPS.ADD_PHONE_NUMBER && (
                            <AddPhoneNumber
                                currentStepIndex={currentStepIndex}
                                incrementStep={incrementStep}
                                savePhoneNumberToVerify={setPhoneNumberToVerify}
                                onPhoneNumberAdded={onPhoneNumberAdded}
                            />
                        )}
                        {stepsConfig[currentStepIndex] === PHONE_VERIFICATION_STEPS.GET_VERIFICATION_CODE && (
                            <GetVerificationCode
                                currentStepIndex={currentStepIndex}
                                incrementStep={incrementStep}
                                isNumberEditable={isNumberEditable}
                                contactPhone={phoneNumberToVerify}
                                saveVerificationType={setVerificationType}
                                onRequestVerificationCode={onRequestVerificationCode}
                            />
                        )}
                        {stepsConfig[currentStepIndex] === PHONE_VERIFICATION_STEPS.VERIFICATION_CODE_SENT && (
                            <VerificationCodeSent
                                currentStepIndex={currentStepIndex}
                                incrementStep={incrementStep}
                                isNumberEditable={isNumberEditable}
                                contactPhone={phoneNumberToVerify}
                                verificationType={verificationType}
                                onVerificationConfirmation={onVerificationConfirmation}
                            />
                        )}
                        {stepsConfig[currentStepIndex] === PHONE_VERIFICATION_STEPS.VERIFICATION_SUCCESS && (
                            <Finished
                                incrementStep={incrementStep}
                                showVerificationModal={showVerificationModal}
                                verificationSuccessfulCTAText={verificationSuccessfulCTAText}
                            />
                        )}
                    </StyledWrapper>
                </div>
            )}
        />
    );
};

PhoneVerificationWizard.propTypes = propTypes;
PhoneVerificationWizard.defaultProps = defaultProps;

export { PhoneVerificationWizard };
